import FooterDataList from "../../../data/FooterDataList";
import LanguagesDataList from "../../../data/LanguagesDataList";
import SocialSVG from "../../../svgs/SocialSVG";
import LogoIpsumSVG from "../../../svgs/LogoIpsumSVG";
import WikiSVG from "../../../svgs/WikiSVG";
import FacebookSVG from "../../../svgs/FacebookSVG";
import TelegramSVG from "../../../svgs/TelegramSVG";
import InstagramSVG from "../../../svgs/InstagramSVG";
import FooterAddress from "../modules/landing/sections/Cards/FooterAddress";

const Footer = () => {
  return (
    <div className="w-full flex flex-col lg:flex-row justify-between items-center border-t border-[#191919] pt-10 sm:px-4 md:px-8 gap-10 mb-14 xl:gap-20 txl:gap-40">
      <div className="w-full h-1/2 flex flex-col justify-between gap-20 lg:gap-52 lg:ml-10">
        <div className="flex flex-col items-start gap-3 text-white">
          <LogoIpsumSVG />
          <h4 className="text-subColor6 text-[12px] sm:text-[16px] max-w-[420px]">
            The first free end-to-end analytics service for the site, designed
            to work with enterprises of various levels and business segments.
          </h4>
          <h3 className="font-semibold italic text-[14px] sm:text-[18px]">
            More about us{" "}
            <span className="text-[40px] sm:text-[48px] leading-[0] relative bottom-[2px]">
              .
            </span>
          </h3>
        </div>
        <div className="flex justify-between items-end">
          <div className="flex flex-wrap gap-1 w-[55px] md:w-[70px] sm:[&>svg]:scale-125 sm:gap-[10px] md:[&>svg]:scale-150 md:gap-4 xl:[&>svg]:scale-[180%] xl:gap-6">
            <SocialSVG /> &nbsp;
            <WikiSVG />
            <FacebookSVG />
            <TelegramSVG />
            <InstagramSVG />
          </div>
          <h4 className="text-subColor6 text-[12px] w-28 sm:text-[16px] sm:w-40">
            © 2021 — Copyright All Rights reserved
          </h4>
        </div>
      </div>
      <div className="w-full h-1/2 flex flex-col lg:gap-44">
        <div className="flex items-center gap-4 w-[60%] mb-10 md:gap-8">
          {FooterDataList.map((item) => (
            <div
              key={item.id}
              className="text-[12px] md:text-[16px] text-subColor6"
            >
              {item.text}
            </div>
          ))}
        </div>
        <div className="flex justify-between lg:mr-10 items-end">
          <div className="flex flex-col justify-between gap-10">
            <FooterAddress
              title="Contact Us"
              text1="+1 (999) 888-77-66"
              text2="hello@logoipsum.com"
            />
            <FooterAddress
              title="Location"
              text1="483920, Moscow,"
              text2="Myasnitskaya 22/2/5, Office 4"
            />
          </div>
          <div className="hidden flex-col gap-3 items-end mini:flex">
            <h3 className="text-white italic">Languages</h3>
            <div className="flex gap-4">
              {LanguagesDataList.map((item) => (
                <div
                  key={item.id}
                  className={`text-[14px] txl:text-[18px] text-subColor6 cursor-pointer italic ${item.id === 1 ? "!text-white" : ""}`}
                >
                  {item.text}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
